export class Utils {
	static scrollToError(): void {
		if (typeof document === "undefined") {
			return;
		}

		const input = document.querySelector<HTMLElement>(".invalid");

		if (!input) {
			return;
		}

		input.scrollIntoView({
			behavior: "smooth",
			block: "center",
			inline: "start",
		});
	}

	static scrollToTop(): void {
		if (typeof window === "undefined") {
			return;
		}

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "auto",
		});
	}
}
